
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from 'lucide-react';

interface CommentGuidelinesProps {
  onClose: () => void;
}

const CommentGuidelines: React.FC<CommentGuidelinesProps> = ({ onClose }) => {
  return (
    <Card className="mb-6">
      <CardHeader className="pb-3">
        <div className="flex justify-between items-center">
          <CardTitle className="text-lg">Community Guidelines</CardTitle>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={onClose}>
            <X className="h-4 w-4" />
          </Button>
        </div>
        <CardDescription>
          Guidelines for participating in our journalism community
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4 text-sm">
        <div>
          <h4 className="font-semibold mb-1">Be Respectful</h4>
          <p className="text-muted-foreground">
            Treat others with respect. Disagreements are natural, but personal attacks, hate speech, and disrespectful comments are not tolerated.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold mb-1">Stay On Topic</h4>
          <p className="text-muted-foreground">
            Keep comments relevant to the article topic. Off-topic discussions may be removed.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold mb-1">Provide Value</h4>
          <p className="text-muted-foreground">
            Aim to contribute meaningfully to the conversation. Share insights, ask thoughtful questions, or offer constructive feedback.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold mb-1">Be Authentic</h4>
          <p className="text-muted-foreground">
            Use only one account and don't impersonate others. Be yourself and engage genuinely.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold mb-1">No Spam</h4>
          <p className="text-muted-foreground">
            Don't post promotional content, spam, or irrelevant links. Commercial solicitation is not allowed.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold mb-1">Respect Privacy</h4>
          <p className="text-muted-foreground">
            Don't share personal information about yourself or others. Respect privacy and confidentiality.
          </p>
        </div>
        
        <div className="pt-2 text-xs">
          <p className="text-muted-foreground">
            Comments violating these guidelines may be removed, and repeated violations may result in account restrictions.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default CommentGuidelines;
